import React from "react";
import { Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import DoughnutChart from "../../../../components/common/Charts/DoughnutChart";
import {
  doughnutChartCommonOptions,
  overviewDashboardChart,
} from "../../../../components/constants/ChartConstant";

const GenderCard = ({ genderStats }) => {
  const { t } = useTranslation();
  const { genderChartDatasetSettings } = overviewDashboardChart;
const data = {
  labels: genderStats?.map((item) => item?.gender) || [],
  datasets: [
    {
      data: genderStats?.map((item) => item?.count) || [], // use counts
      ...genderChartDatasetSettings,
    },
  ],
};

const doughnutChartOptions = {
  plugins: {
    legend: {
      position: "right",
      labels: {
        usePointStyle: true,
        boxWidth: 10,
        boxHeight: 10,
        padding: 20,
        font: {
          size: 12,
        },
        generateLabels: (chart) => {
          return chart.data.labels.map((label, i) => ({
            text: ` ${label}  ${genderStats[i]?.percentage}%`,  // show percentage
            fillStyle: chart.data.datasets[0]?.backgroundColor[i],
            hidden: false,
            index: i,
            strokeStyle: chart.data.datasets[0]?.backgroundColor[i],
          }));
        },
      },
    },
    tooltip: {
      enabled: true,
      callbacks: {
        label: function (context) {
          const label = context.label || '';
          const count = context.raw || 0;
          const total = context.chart._metasets[0].total || context.dataset.data.reduce((a, b) => a + b, 0);
          const percentage = ((count / total) * 100).toFixed(2);

          return ` ${label}: ${count} (${percentage}%)`;
        },
      },
    },
  },
  cutout: "60%",
};

  return (
    <Col lg={4} className="ps-0">
      <div className="gender_common">
        <h2 className="fs_20">{t("Gender")}</h2>
        <DoughnutChart
          data={data}
          options={doughnutChartOptions}
          width={150}
          height={150}
        />
      </div>
    </Col>
  );
};

export default GenderCard;
